import ProfileTypeView from "./ProfileTypeView";
export default ProfileTypeView;